<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :value="ruleGame"/>
      <rule-game :value="ruleScore"/>
      <rule-game :value="ruleInscreasePoint"/>
      <rule-game :value="ruleSpecial"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/bingo/Board_Bingo.png';
import ruleText1 from '../../assets/gamerule/bingo/Bingo_Text1.png';
import ruleBingo1 from '../../assets/gamerule/bingo/Bingo_Info_Game1.png';
import ruleBingo2 from '../../assets/gamerule/bingo/Bingo_Info_Game2.png';
import ruleBingo3 from '../../assets/gamerule/bingo/Bingo_Info_Game3.png';
import ruleBingo4 from '../../assets/gamerule/bingo/Bingo_Info_Game4.png';
import ruleBingo5 from '../../assets/gamerule/bingo/Bingo_Info_Game5.png';
import ruleBingo6 from '../../assets/gamerule/bingo/Bingo_Info_Game6.png';
import ruleBingo7 from '../../assets/gamerule/bingo/Bingo_Info_Game7.png';
import ruleBingo8 from '../../assets/gamerule/bingo/Bingo_Info_Game8.png';
import ruleBingo9 from '../../assets/gamerule/bingo/Bingo_Info_Game9.png';
import ruleBingo10 from '../../assets/gamerule/bingo/Bingo_Info_Game10.png';
import ruleBingo11 from '../../assets/gamerule/bingo/Bingo_Info_Game11.png';
import ruleBingoAsset1 from '../../assets/gamerule/bingo/Bingo_Asset_Info_Web1.png';
import ruleBingoAsset2 from '../../assets/gamerule/bingo/Bingo_Asset_Info_Web_Text2.png';

export default {
  name: 'rule_bingo',
  data() {
    return {
      ruleHeader: {
        gameName: 'บิงโก (Bingo)',
        boardImg: Board,
      },
      ruleGame: [
        {
          type: 'text-header',
          text: 'อัตราจ่าย',
          class: 'textHighlight',
        },
        {
          type: 'text',
          text: 'อัตราจ่าย 1 : 0.97',
        },
        {
          type: 'text',
          text: 'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
        },
        {
          type: 'imageNoborder',
          image: ruleText1,
          class: 'w-30',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'สามารถเริ่มเล่นได้ตั้งแต่',
          classMain: 'ml-1',
          textSubcolor: '2',
          textSub1: 'ขึ้นไปและสูงสุด',
          textSubcolor1: '4',
          textSub2: 'เมื่อเริ่มเกมส์ผู้เล่นจะได้การ์ดคนละ',
          textSubcolor2: '1',
          textSub3: 'โดยการ์ดของตัวเราเองจะเด่นกว่าการ์ด',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ของผู้เล่นอื่น',
          classMain: 'ml-1',
          textSubcolor: '***',
          textSub1: 'เมื่อได้การ์ดมาการ์ดจะยังไม่เปิดให้เห็นเลขบนการ์ด',
          textSubcolor1: '***',
        },
      ],
      ruleScore: [
        {
          type: 'twoImage',
          image: ruleBingo1,
          class: 'w-90',
          image2: ruleBingo2,
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'จากนั้นเกมจะสุ่มผู้เล่นเพื่อให้เลือกเลขที่จะเป็นเลขโบนัส เช่น เลขโบนัสคือเลข',
          class: 'ml-1',
          textSubcolor: '8',
          textSub1: 'และถ้าในแถวที่ผู้เล่นบิงโกมีเลข',
          textSubcolor1: '8',
          textSub2: 'ผู้เล่นจะได้รับเงินรางวัล',
          textSubcolor2: 'x2',
        },
        {
          type: 'image',
          image: ruleBingo3,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'เมื่อสุ่มได้เลขโบนัสแล้วการ์ดของผู้เล่นถึงจะเปิด การ์ดแต่ละใบจะมีช่อง',
          class: 'ml-1',
          textSubcolor: 'FREE',
          textSub1: 'คือช่องที่อยู่ตรงกลางของการ์ด จากนั้นเกมส์จะให้ผู้เล่น',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'สุ่มตัวเลขบิงโก',
          class: 'ml-1',
          textSubcolor: '( มีเลข 1 - 60 )',
          textSub1: 'ผู้เล่นจะได้สุ่มทุกคนโดยเรียงจากผู้เล่นคนที่',
          textSubcolor1: '1 2 3',
          textSub2: 'และ',
          textSubcolor2: '4',
          textSub3: 'ถ้าเลขที่ผู้เล่นสุ่มมีบนการ์ดเกมจะวางฝาบนการ์ดให้โดยอัตโนมัติ',
        },
        {
          type: 'twoImage',
          image: ruleBingo4,
          class: 'w-90',
          image2: ruleBingoAsset1,
        },
        {
          type: 'text',
          text: 'หากผลออกแล้วผู้เล่นดูผลที่ออกไม่ทัน สามารถดูผลที่ออกไปแล้วได้ โดยดูจากตารางด้านซ้าย ผลที่ออกไปแล้วเลขจะมีกรอบสีแดงหรือดูผลที่ออกล่าสุดได้โดยดูจากลูกบอลด้านขวา',
        },
        {
          type: 'twoImage',
          image: ruleBingo5,
          class: 'w-90',
          image2: ruleBingo6,
        },
        {
          type: 'text',
          text: 'เมื่อมีผู้เล่นได้บิงโก เกมจะจบลงทันทีและจะขึ้นหน้าสรุปผล เมื่อเริ่มตาใหม่ผู้เล่นที่ได้เงินรางวัลมากที่สุดจะได้สุ่มเลขเป็นคนแรก',
        },
        {
          type: 'textSubcolor-bingo',
          textSubcolor: '***',
          textSub1: 'กรณีที่มีผู้เล่น',
          textSubcolor1: '2',
          textSub2: 'หรือ',
          textSubcolor2: '3',
          textSub3: 'คนในห้อง และได้บิงโกทั้งทุกคน รอบนั้นจะไม่เสียเงินเดิมพันใดๆ',
          textSubcolor3: '***',
        },
        {
          type: 'twoImage',
          image: ruleBingo7,
          class: 'w-90',
          image2: ruleBingo8,
        },
      ],
      ruleInscreasePoint: [
        {
          type: 'imageNoborder',
          image: ruleBingoAsset2,
          class: 'w-30',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นที่ได้บิงโก',
          textSubcolor: '1',
          textSub1: 'ไลน์ จะได้เงินรางวัล',
          textSubcolor1: 'X1',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นที่ได้บิงโก',
          textSubcolor: '2',
          textSub1: 'ไลน์ จะได้เงินรางวัล',
          textSubcolor1: 'X1.5',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นที่ได้บิงโกมากกว่า',
          textSubcolor: '2',
          textSub1: 'ไลน์ จะได้เงินรางวัล',
          textSubcolor1: 'X3',
        },
        {
          type: 'textSubcolor-bingo',
          textSubcolor: '***',
          textSub1: 'ถ้าหากแถวที่บิงโกมีเลขโบนัสจะได้รับเงินรางวัล',
          textSubcolor1: 'X2',
          textSub2: 'เช่น ผู้เล่นได้บิงโก',
          textSubcolor2: '3',
          textSub3: 'ไลน์ และมีเลขโบนัสอยู่ในไลน์นั้นๆ จะเพิ่มเป็น',
          textSubcolor3: 'X6 ***',
        },
      ],
      ruleSpecial: [
        {
          type: 'image',
          image: ruleBingo9,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'กรณีที่มีผู้เล่นชนะ',
          textSubcolor: '1',
          textSub1: 'คน',
        },
        {
          type: 'text',
          text: 'ผู้เล่นที่บิงโกชนะ จะได้เงินเดิมพันของผู้เล่นที่แพ้ทั้งหมด',
        },
        {
          type: 'image',
          image: ruleBingo10,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'กรณีที่มีผู้เล่นชนะ',
          class: 'ml-1',
          textSubcolor: '2',
          textSub1: 'คน',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'เช่น ห้องมือใหม่',
          class: 'ml-1',
          textSubcolor: '50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นคนที่',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'ได้',
          textSubcolor1: '2',
          textSub2: 'ไลน์, ผู้เล่นคนที่',
          textSubcolor2: '2',
          textSub3: 'ได้',
          textSubcolor3: '1',
          textSub4: 'ไลน์, ผู้เล่นคนที่',
          textSubcolor4: '3',
          textSub5: ',',
          textSubcolor5: '4',
          textSub6: 'แพ้',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นที่แพ้จะต้องเสียเงินเดิมพัน เท่ากับเงินรางวัลที่ผู้เล่นคนที่',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'ได้ ( เนื่องจากผู้เล่นคนที่',
          textSubcolor1: '1',
          textSub2: 'มีการชนะเงินเดิมพันมากที่สุด )',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'และผู้เล่นที่ชนะบิงโกจะได้เงินรางวัลโดยหารตามสัดส่วน ผู้เล่นที่ได้อันดับ',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'จะได้เงินรางวัลมากสุดและไล่ลงมาตามสัดส่วน',
        },
        {
          type: 'image',
          image: ruleBingo11,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'กรณีที่มีผู้เล่นชนะ',
          class: 'ml-1',
          textSubcolor: '3',
          textSub1: 'คน',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'เช่น ห้องมือใหม่',
          class: 'ml-1',
          textSubcolor: '50',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นคนที่',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'ได้',
          textSubcolor1: '2',
          textSub2: 'ไลน์, ผู้เล่นคนที่',
          textSubcolor2: '2',
          textSub3: 'ได้',
          textSubcolor3: '1',
          textSub4: 'ไลน์, ผู้เล่นคนที่',
          textSubcolor4: '3',
          textSub5: 'ได้',
          textSubcolor5: '1',
          textSub6: 'ไลน์, ผู้เล่นคนที่',
          textSubcolor6: '4',
          textSub7: 'แพ้',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'ผู้เล่นที่แพ้จะต้องเสียเงินเดิมพัน เท่ากับเงินรางวัลที่ผู้เล่นคนที่',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'ได้ ( เนื่องจากผู้เล่นคนที่',
          textSubcolor1: '1',
          textSub2: 'มีการชนะเงินเดิมพันมากที่สุด )',
        },
        {
          type: 'textSubcolor-bingo',
          textSub: 'และผู้เล่นที่ชนะบิงโกจะได้เงินรางวัลโดยหารตามสัดส่วน ผู้เล่นที่ได้อันดับ',
          class: 'ml-1',
          textSubcolor: '1',
          textSub1: 'จะได้เงินรางวัลมากสุดและไล่ลงมาตามสัดส่วน',
        },
      ],

    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
